import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { GfTranslateService } from '../../../../../core/services/core.translate.service';
import { UserService } from '../../../../../core/services/core.user.service';
import { MonitorService } from '../../../../../core/services/core.monitor.service';
import * as _ from 'lodash';

@Component({
  selector: 'trackeritem-monitor-toggle',
  template: `<button id="TIMonitor1" type="button" style="z-index: 0;" 
              [title]="monitorButtonTitle(trackeritem)" 
              class="btn" 
              (click)="toggleMonitor()" 
              [ngClass]="{ 'btn-primary': monitoring, 'btn-default': !monitoring }" 
              data-toggle="button">
              <span class="glyphicon" 
                [ngClass]="{ 'glyphicon-eye-open': monitoring, 'glyphicon-eye-close': !monitoring }">
              </span>
            </button>`
})
export class TrackeritemMonitorToggleComponent implements OnInit, OnChanges {
  @Input() trackeritem: any;
  monitoring: boolean = false;

  constructor(
    private translateService: GfTranslateService,
    private userService: UserService,
    private monitorService: MonitorService
  ) {}

  ngOnInit() {
    this.init();
  }

  ngOnChanges() {
    this.init();
  }

  monitorButtonTitle(item: any): string {
    if (this.monitoring) {
      return this.translateService.translate('You are currently monitoring this tracker item. Click to stop monitoring');
    } else {
      return this.translateService.translate('You are not monitoring this tracker item. Click to start monitoring');
    }
  }

  toggleMonitor() {
    if (this.monitoring) {
      this.monitorService.unset('trackeritem', this.trackeritem.id).then(() => {
        this.monitoring = false;
      });
    } else {
      this.monitorService.set('trackeritem', this.trackeritem.id).then(() => {
        this.monitoring = true;
      });
    }
  }

  private init() {
    this.monitoring = _.size(_.find(
      _.get(this.trackeritem, 'rel.monitoring', []),
      (monitor) => monitor.id === this.userService.session.getUserId()
    )) > 0;
  }
}
